import { Box, Divider } from '@cowbell/ui';
import { MetadataAndActions } from './CmailDetails/MetadataAndActions';
import { Title } from './CmailDetails/Title';
import { MessageBody } from './CmailDetails/MessageBody';
import { CmailDetailsPanel } from '../CmailDetailsPanel';
import type {
  MessageInfo,
  MessageInfoChild,
  EnrichedCmailMessage,
} from '../../../../api/cmail/cmail.dto';
import classes from './CmailDetails.module.css';

interface ThreadContext {
  isThreaded: boolean;
  isExpanded: boolean;
  onToggleExpansion: () => void;
  messageIndex: number;
  isCurrentMessage: boolean;
  totalMessages: number;
}

export const CmailDetails = ({
  message,
  enrichedMessage,
  threadContext,
}: {
  message: MessageInfo | MessageInfoChild;
  enrichedMessage: EnrichedCmailMessage;
  threadContext?: ThreadContext | null;
}) => {
  return (
    <>
      <Box className={classes.panelOffset}>
        <CmailDetailsPanel
          message={enrichedMessage}
          fullMessageDetails={message as MessageInfo}
          threadContext={threadContext}
        />
      </Box>
      {!threadContext || threadContext.isExpanded ? (
        <Box className={classes.messageSurface}>
          <Title message={message} />
          <MetadataAndActions message={message} />
          <Divider className={classes.divider} />
          <Box className={classes.messageBodyBorder}>
            <MessageBody message={message} />
          </Box>
        </Box>
      ) : null}
    </>
  );
};
